module.exports = __webpack_public_path__ + "static/media/lockheed.2efe1e95.png";